export default "__VITE_ASSET__DUg9U0pt__"